import { render, staticRenderFns } from "./DeckFilterMenu.vue?vue&type=template&id=e47b2ca0"
import script from "./DeckFilterMenu.vue?vue&type=script&lang=ts"
export * from "./DeckFilterMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports